export function initMap() {
  let contentString = '';

  const setContentString = (item) => `
        <div class="google-map-item">
          <address><strong>${item.custom.name}</strong><br/>
          ${item.custom.address}</address>
        </div>`;

   const setContentStringDealerSearch = (item) => `
        <div class="google-map-item">
          <address><strong><a onclick="showDealer(${item.custom.dealerid})" data-bs-toggle="modal" data-bs-target="#dealerFormModal">${item.custom.name}</a></strong><br/>
          ${item.custom.address}</address>
        </div>`;

  const onMarkerClick = (marker) => {
    if (window.locations.filter(l => l.dealerid != null).length > 0) {
      contentString = setContentStringDealerSearch(marker);
    } else {
      contentString = setContentString(marker);
    }
    window.infoWindow.setContent(contentString);
    window.infoWindow.open(window.mapInstance, marker);
  };

  const deleteMarkers = () => {
    if (window.mapMarkers) {
      for (let i = 0; i < window.mapMarkers.length; i++) {
        window.mapMarkers[i].setMap(null);
      }
    }
    window.mapMarkers = [];
  };

  const setMarkers = () => {
    deleteMarkers();
    const latlngbounds = new window.google.maps.LatLngBounds();

    window.locations.forEach(function (item, index) {
      const myLatLng = new window.google.maps.LatLng(item.lat, item.long);
      latlngbounds.extend(myLatLng);

      const pinDiamondImage = {
        url: "/frontend/dist/images/map-marker-diamond.svg",
        scaledSize: new google.maps.Size(29, 40)
      };

      const redPinImage = {
        url: '/frontend/dist/images/map-marker-red.svg',
        scaledSize: new google.maps.Size(29, 40)
      }

      if (window.locations.filter(l => l.dealerid != null).length > 0) {
        const marker = new window.google.maps.Marker({
          position: myLatLng,
          map: window.mapInstance,
          icon: redPinImage,
          custom: {
            name: item.name,
            dealerid: item.dealerid,
            isdiamond: item.isdiamond,
            address: item.address,
            phone: item.phone,
            url: item.url,
            googleMapsUrl: item.googleMapsUrl,
            index: index + 1
          },
        });
      } else {
        const marker = new window.google.maps.Marker({
          position: myLatLng,
          map: window.mapInstance,
          custom: {
            name: item.name,
            address: item.address,
            phone: item.phone,
            url: item.url,
            googleMapsUrl: item.googleMapsUrl,
            index: index + 1
          },
        });
      }

      window.google.maps.event.addListener(marker, 'click', function () {
        onMarkerClick(marker);
      });

      if (item.isdiamond) {
        marker.setIcon(pinDiamondImage);
}

      window.mapMarkers.push(marker);
    });

    window.mapInstance.fitBounds(latlngbounds);
  };

  const initialize = () => {
    if (typeof window.locations === 'undefined') return;
    if (window.locations.filter(l => l.dealerid != null).length > 0) { // special case for Dealer Search Widget
      window.mapInstance = new window.google.maps.Map(document.getElementById('map'), {
        zoom: 10,
        maxZoom: 15,
        mapTypeControl: false,
        streetViewControl: false,
        styles: [{
          stylers: [{
            saturation: -100
          }]
        }]
      });
    } else {
      window.mapInstance = new window.google.maps.Map(document.getElementById('map'), {
        zoom: 10,
        maxZoom: 15
      });
    }
    

    window.infoWindow = new window.google.maps.InfoWindow({
      content: contentString,
      minWidth: 240,
      maxWidth: 330,
    });

    window.google.maps.event.addListener(window.mapInstance, 'click', function () {
      window.infoWindow.close();
    });

    setMarkers();
  };

  if (window.google && window.locations) {
    if (!window.mapInstance) {
      window.google.maps.event.addDomListener(window, 'load', initialize);
    } else {
      setMarkers();
    }
  }
};
initMap();
export { initMap as default };
